import React, { FunctionComponent } from 'react';
import DashboardLayout from '../../components/layout/layout';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Chip
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import DescriptionIcon from '@mui/icons-material/Description';

const SalesToolDetail: FunctionComponent = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { itemId } = useParams<{ itemId: string }>();

  const handleBack = () => {
    navigate('/resources');
  };

  const itemName = itemId ? decodeURIComponent(itemId) : 'Item Not Found';

  return (
    <DashboardLayout
      title={itemName}
      initialBreadcrumbs={"Sales Tools"}
      levelBreadcrumbs={"Sales Tools"}
      breadcrumbs={itemName}
      activeMenu={'resources'}
    >
      <Box>
        {/* Content Section */}
        <Card sx={{ mb: 3, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)', borderRadius: '12px' }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="body1" sx={{ color: '#333', mb: 2 }}>
              This is a detailed view for the sales tool item: <strong>{itemName}</strong>
            </Typography>
            
            <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
              Here you would typically display:
            </Typography>
            
            <Box sx={{ pl: 2 }}>
              <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                • Item description and details
              </Typography>
              <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                • Download links or file previews
              </Typography>
              <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                • Related resources and materials
              </Typography>
              <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                • Contact information for support
              </Typography>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Chip 
                label="Sales Tool" 
                size="small" 
                sx={{ 
                  backgroundColor: '#666', 
                  color: 'white',
                  fontSize: '0.75rem'
                }} 
              />
            </Box>
          </CardContent>
        </Card>

        {/* Back Button */}
        <Box sx={{ textAlign: 'left', mt: 4 }}>
          <Button
            variant="contained"
            onClick={handleBack}
            sx={{
              bgcolor: '#c8102e',
              textTransform: 'none',
              fontWeight: 600,
              ...theme.typography.button,
              '&:hover': { bgcolor: '#a30f24' },
            }}
          >
            BACK
          </Button>
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default SalesToolDetail;
